export default {"src":"/_next/static/media/close.daf6535a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};